import { CloseCommand } from "appworks/commands/comms/close-command";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import RespinResult from "slotworks/model/gameplay/records/results/respin-result";

export class GameOverState extends State {
    public onEnter() {
        Services.get(TransactionService).setBalance(gameState.getCurrentGame().balance);

        Components.get(FooterComponent)?.showNoWin();

        uiFlags.set(UIFlag.GAME_IN_PROGRESS, false);

        // TODO: Not necessarily awaiting response here - would probably be better to take this flag out
        // of every state and move it into connector. Make request -> set it to true until response comes back
        uiFlags.set(UIFlag.AWAITING_RESPONSE, true);

        const respinResult = gameState.getCurrentGame().getLatestResultOfType(RespinResult);
        if (respinResult && respinResult.respinsRemaining) {
            this.complete();
            return;
        }

        const record = gameState.getCurrentGame().getCurrentRecord();
        if (!(record instanceof FreespinRecord)) {
            this.closeGame().then(() => {
                uiFlags.set(UIFlag.AWAITING_RESPONSE, false);
                this.complete();
            });
        }
    }

    protected closeGame() {
        return CloseCommand();
    }
}
